import {
  Alert,
  Button,
  Col,
  Dropdown,
  Grid,
  Input,
  Menu,
  message,
  Modal,
  Row,
  Space,
  Table,
  Tabs,
  Typography,
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import './superadmin.less';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getCurrnetUserData, viewAs } from '../../store/slices/loginSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  MoreOutlined,
  PlusOutlined,
  HistoryOutlined,
  CloseCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { RESTDeleteOrg, RESTDemoOrg } from 'utils/RESTApi';
import { ECHOIMAGES } from 'Assets/Images';
import { seacrhUsersOrganizationCustom } from 'utils/Actions';
import OrganizationModal from './components/OrganizationModal';
import EditOrgModal from './components/EditOrgModal';
import { getOrganizations } from 'utils/CommonFunctions';
import TableSkeleton from 'Common/TableSkeleton';
import { setDefaultBatchID } from 'store/slices/compareSlice';

function SuperAdmin() {
  const loginUsrOrg = useSelector(getCurrnetUserData);

  const [organizationDetails, setOrganizationDetail] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOrganizationModalOpen, setIsOrganizationModalOpen] = useState(false);
  const [editOrganizationModal, setEditOrganizationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgName, setOrgName] = useState({});
  const [orgDeleteID, setOrgDeleteID] = useState([]);
  const [userCount, setUserCount] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const { DeleteIcon } = ECHOIMAGES.superAdminIcons;
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const showOrgModal = () => {
    setIsOrganizationModalOpen(true);
  };
  const showEditOrgModal = () => {
    setEditOrganizationModal(true);
  };
  const dispatch = useDispatch();

  const fetchOrganizations = async () => {
    setTableLoading(true);
    try {
      const { data } = await getOrganizations();
      let sortedList = data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setOrganizationDetail(sortedList);
      setTableLoading(false);
    } catch (error) {
      setTableLoading(false);
      console.log(error);
    }
  };

  const deleteOrganization = async () => {
    setLoading(true);
    try {
      let inputData = {
        org_id: orgDeleteID,
      };
      await RESTDeleteOrg(inputData);
      await fetchOrganizations();
      setLoading(false);
      message.warning('Organization delete initiated.... ');
      setIsModalOpen(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getAllUsersCount = async () => {
    try {
      let res = await seacrhUsersOrganizationCustom();
      setUserCount(
        res?.data?.searchUsers?.aggregateItems?.[0]?.result?.buckets
      );
    } catch (err) {
      console.log(err);
    }
  };

  const [showAlert, setShowAlert] = useState(false);

  const createDemoOrganization = async () => {
    try {
      let input = {
        inviter_email: loginUsrOrg?.email,
        inviter_name: loginUsrOrg?.firstName + ' ' + loginUsrOrg?.lastName,
      };
      setShowAlert(true);
      await RESTDemoOrg(input);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchOrganizations();
    getAllUsersCount();
  }, []);

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '35%',
      render: (text, row) => {
        return <span className="table-font">{text}</span>;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 300,
      ...getColumnSearchProps('name'),
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, row) => (
        <Link
          className="domain-color"
          onClick={() => {
            dispatch(viewAs(row));
            dispatch(setDefaultBatchID(''));
          }}
          to={{ pathname: '/', state: { orgId: row?.id } }}
        >
          <span className="table-font">{text}</span>
        </Link>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 100,
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      render: (text) => (
        <span className="table-font">{moment(text).format('l')}</span>
      ),
    },
    {
      title: 'Users',
      dataIndex: 'userCount',
      key: 'userCount',
      width: 80,
      render: (_, row) => {
        let allUsersCount = userCount?.find((item) => item?.key === row?.id);
        return (
          <span className="table-font">
            {allUsersCount?.doc_count ? allUsersCount?.doc_count : 0}
          </span>
        );
      },
    },
    {
      title: '',
      dataIndex: 'sction',
      key: 'action',
      fixed: 'right',
      width: 50,
      render: (text, row) => (
        <Dropdown
          overlay={
            <Menu
              items={[
                {
                  label: <span>Delete</span>,
                  key: '1',
                  onClick: () => {
                    showModal();
                    setOrgDeleteID(row?.id);
                  },
                },
                {
                  label: <span>Edit</span>,
                  key: '2',
                  onClick: () => {
                    showEditOrgModal();
                    setOrgName(row);
                  },
                },
              ]}
            />
          }
          trigger={['click']}
        >
          <MoreOutlined style={{ color: '#5AACC9' }} className="fs-20" />
        </Dropdown>
      ),
    },
  ];
  const items = [
    {
      key: '1',
      label: `Organization Management`,
      children: tableLoading ? (
        <>
          <TableSkeleton />
          <TableSkeleton />
        </>
      ) : (
        <Table
          pagination={false}
          columns={columns}
          dataSource={organizationDetails}
          className="admin-table"
          scroll={{ x: 1000 }}
          size={screens.xxl ? 'middle' : 'small'}
        />
      ),
    },
  ];
  const { Text } = Typography;

  const userMenu = (
    <Menu
      className="dropdown-container"
      items={[
        {
          label: <Text>New Organization</Text>,
          key: 'Profile',
          onClick: () => showOrgModal(),
        },
        {
          label: <Text>Demo Organization</Text>,
          key: 'Logout',
          onClick: () => createDemoOrganization(),
        },
      ]}
    />
  );
  return (
    <>
      <div className="background-white main-div">
        <Space>
          {showAlert && (
            <Alert
              className="alert-message"
              // eslint-disable-next-line
              description={
                <>
                  Demo organization creation is in progress. You will <br />{' '}
                  receive the summary via email upon completion.
                </>
              }
              type="info"
              showIcon
              icon={<HistoryOutlined className="inprogress-icon" />}
              closable
              onClose={() => setShowAlert(false)}
              closeIcon={<CloseCircleOutlined className="close-icon" />}
            />
          )}
        </Space>
        <Row justify="center" className="row-data idea-header">
          <Col span={24}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              tabBarExtraContent={
                <>
                  <Dropdown
                    overlay={userMenu}
                    trigger={['click']}
                    className="org-color"
                  >
                    <span className="cursor-pointer fs-14 capital-text">
                      <PlusOutlined
                        style={{
                          padding: screens.xs ? 0 : '0px 10px',
                        }}
                        className="plus-icon"
                      />
                      Add
                    </span>
                  </Dropdown>
                </>
              }
              className="org-tab"
            />
          </Col>
        </Row>
      </div>
      <Modal
        open={isModalOpen}
        onOk={deleteOrganization}
        onCancel={handleCancel}
        confirmLoading={loading}
        centered
        okText="Yes"
        className="delete-user-modal"
      >
        <Row justify="center">
          <img src={DeleteIcon} alt="" />
        </Row>
        <Row justify="center">
          <Typography.Title level={4}>
            Do you really want to Delete this Organization?
          </Typography.Title>
        </Row>
      </Modal>
      <OrganizationModal
        isOrganizationModalOpen={isOrganizationModalOpen}
        setIsOrganizationModalOpen={setIsOrganizationModalOpen}
        fetchOrganizations={fetchOrganizations}
        getAllUsersCount={getAllUsersCount}
      />
      <EditOrgModal
        editOrganizationModal={editOrganizationModal}
        setEditOrganizationModal={setEditOrganizationModal}
        orgName={orgName}
        fetchOrganizations={fetchOrganizations}
      />
    </>
  );
}

export default SuperAdmin;
